import { render, staticRenderFns } from "./avgConsumption.vue?vue&type=template&id=6e99a8c2&"
import script from "./avgConsumption.vue.js?vue&type=script&lang=js&"
export * from "./avgConsumption.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports